import { render, staticRenderFns } from "./DrugBank.vue?vue&type=template&id=1893aa54&scoped=true"
import script from "./DrugBank.vue?vue&type=script&lang=js"
export * from "./DrugBank.vue?vue&type=script&lang=js"
import style0 from "./DrugBank.vue?vue&type=style&index=0&id=1893aa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1893aa54",
  null
  
)

export default component.exports